import {Edit} from "react-admin";
import {QuizAssessmentQuestionForm} from "./component/quiz-assessment-question.form";

export function QuizAssessmentQuestionEdit(props) {
  return (
    <>
      <Edit
        mutationMode="pessimistic"
        {...props}
      >
        <QuizAssessmentQuestionForm />
      </Edit>
    </>
  )
}
